export default __webpack_public_path__ + "static/media/paymentFailure.3d66a7fd.gif";